"use client";

import { useAuthBlobUrl } from "@/lib/auth-blob";

/**
 * Картинка из приватной отдачи бэка (например /rd-files/*, /plch-files/*, /as-files/*):
 * fetch с Bearer-токеном → blob URL (общая реализация в lib/auth-blob).
 * http(s)/data-URL рендерятся как есть. Прозрачный PNG/WebP сохраняет
 * прозрачность (нет подложки). На 404 — ничего не рисует.
 */
export function AuthImage({
  src, alt, className, style, onClick,
}: {
  src: string | undefined | null;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}) {
  const { url } = useAuthBlobUrl(src, { mode: "any" });
  if (!url) return null;
  return <img src={url} alt={alt ?? ""} className={className} style={style} onClick={onClick} />;
}
